var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component, Vue, Watch, Model } from "vue-facing-decorator";
import { ReportClient, CompaniesClient, AutomaticDischargeReportModel, UpsertAutomaticDischargeReportCommand } from "@/app/api/battery-portal-api";
import ReportScheduleedLogVue from "@/app/vues/reports/report-scheduled-log.vue";
import ContactsVue from "@/app/vues/components/contacts.vue";
import { HttpHelper } from "@/app/utils/http-helper";
import { Notifier } from "@/common/utils/notifier";
import moment from 'moment';
import store from "@/app/store/store";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const reportClient = new ReportClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
let AutomaticDischargeReportSettingsVue = class AutomaticDischargeReportSettingsVue extends Vue {
    constructor() {
        super(...arguments);
        this.showModal = false;
        this.model = new AutomaticDischargeReportModel();
        this.companies = [];
        this.showLog = false;
        this.working = false;
    }
    created() {
        this.getCompanies();
    }
    getCompanies() {
        return __awaiter(this, void 0, void 0, function* () {
            this.working = true;
            return yield companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = companies;
                if (!companies.length)
                    return;
                if (this.model.companyId)
                    return;
                let companyId = companies[0].value;
                this.model.companyId = companyId;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    onCompanyChanged() {
        reportClient
            .getAutomaticDischargeReportSettingsForCompany(this.model.companyId)
            .then(response => {
            var _a, _b;
            var _c, _d;
            if (!response) {
                this.model.id = 0;
                this.model.enabled = false;
                this.model.imperialMeasurements = store.getters["loginModule/isUsingImperialMeasurementSystem"];
                this.model.minDurationSeconds = 60;
                this.setFieldValue("minDurationSeconds", 60);
                this.model.contactIds = new Array();
                this.model.contactGroupIds = new Array();
                return;
            }
            this.model = response;
            (_a = (_c = this.model).contactIds) !== null && _a !== void 0 ? _a : (_c.contactIds = []);
            (_b = (_d = this.model).contactGroupIds) !== null && _b !== void 0 ? _b : (_d.contactGroupIds = []);
            this.setFieldValue("minDurationSeconds", this.model.minDurationSeconds);
        });
    }
    save() {
        var _a, _b, _c;
        if (this.working)
            return;
        if ((((_b = (_a = this.model) === null || _a === void 0 ? void 0 : _a.contactIds) === null || _b === void 0 ? void 0 : _b.length) || 0) <= 0 && (((_c = this.model.contactGroupIds) === null || _c === void 0 ? void 0 : _c.length) || 0) <= 0) {
            Notifier.onWarning("Select at least one Contact or Contact Group in the list!");
            return;
        }
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            this.model.timezoneOffset = moment().utcOffset();
            reportClient
                .upsertAutomaticDischargeReportSettings(new UpsertAutomaticDischargeReportCommand({ requestModel: this.model }))
                .then(id => {
                Notifier.onOk();
                this.model.id = id;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, (ctx) => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    get companyId() {
        return this.companies.filter(item => {
            return item.value == this.model.companyId;
        })[0] || null;
    }
    ;
    set companyId(item) {
        if (!item)
            return;
        this.model.companyId = item.value;
    }
    ;
};
__decorate([
    Model(),
    __metadata("design:type", Boolean)
], AutomaticDischargeReportSettingsVue.prototype, "showModal", void 0);
__decorate([
    Watch("model.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AutomaticDischargeReportSettingsVue.prototype, "onCompanyChanged", null);
AutomaticDischargeReportSettingsVue = __decorate([
    Component({
        name: "AutomaticDischargeReportSettingsVue",
        expose: ["show"],
        emits: ["updateCount", "updateScheduleList"],
        components: {
            ReportScheduleedLogVue,
            ContactsVue
        },
        setup() {
            const { errors, handleSubmit, defineInputBinds, setFieldValue } = useForm({
                validationSchema: yup.object({
                    minDurationSeconds: yup.number().integer().min(0).max(3600),
                })
            });
            const minDurationSecondsVal = defineInputBinds('minDurationSeconds');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                minDurationSecondsVal
            };
        }
    })
], AutomaticDischargeReportSettingsVue);
export default AutomaticDischargeReportSettingsVue;
